import { render, staticRenderFns } from "./k2Textarea.vue?vue&type=template&id=11dd7cea"
import script from "./k2Textarea.vue?vue&type=script&lang=js"
export * from "./k2Textarea.vue?vue&type=script&lang=js"
import style0 from "./k2Textarea.vue?vue&type=style&index=0&id=11dd7cea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports